import React from 'react'
import ProductsSectionTitle from '../ProductsSectionTitle'
import { Element } from 'react-scroll'
import { Link } from 'react-router-dom'

const MEAIndustryApplications = () => {

  const industryApplications = [
    {
      title: "Recommendation Systems",
      description: "Recommending optimal irrigation and planting strategies using sensor-driven insights.",
      link: "agriculture",
    },
    {
      title: "Predictive Analytics",
      description: "Wildfire risk prediction, energy forecasting, microgrid optimization.",
      link: "energy",
    },
    {
      title: "Anomaly Detection",
      description: "Detecting irregularities in hydrogen storage systems for performance optimization.",
      link: "manufacturing",
    },
    {
      title: "Generative AI",
      description: "Real-time speech-to-text transformation and correction; potentially creative rehab tools.",
      link: "healthcare",
    },
    {
      title: "Knowledge Mining",
      description: "Extracting operational intelligence from sensor data for optimal WEC positioning.",
      link: "maritime",
    },
    {
      title: "Sentiment Analysis",
      description: "Tracking citizen sentiment from social media and community platforms.",
      link: "public-sector",
    },
  ]

  return (
    <>
      <Element
        name="MEAIndustryApplications"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <ProductsSectionTitle
                classes = "text-center"
                title = "Industry Applications"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              <p className="text-center">How our Edge AI solutions are transforming operations across sectors.</p>
            </div>
            {industryApplications.map((application) => <div className="col-12 col-lg-4 px-0 px-md-4 mt-4 mt-md-5" key={application.title}>
              <div className="home-applied-ai-solutions-card p-4 h-100">
                <h5 className="mt-3 mb-3">{application.title}</h5>
                <p>{application.description}</p>
                <Link className="d-flex flex-row align-items-center justify-content-start gap-2 home-links" to={`/solutions/${application.link}`}>Learn more<i className="icon-arrow-right-line-right"></i></Link>
              </div>
            </div>)}
            <div className="col-12 mt--80 px-0 px-md-4">
              <div className="row g-5 position-relative ba-footer">
                <div className="col-lg-7 p-0 mt-0">
                  <h3 className="color-white">Ready to Deploy Edge AI?</h3>
                  <p className="color-white">Connect with our experts to discuss how our<br></br> Edge AI solutions can transform your operations.</p>
                  <Link to="/contact-us">Contact Sales <img src={`${process.env.PUBLIC_URL}/images/business-accelerator/icons/maki_arrow.svg`} alt="right arrow" /></Link>
                </div>
                <div className="col-lg-2 d-none d-md-block"></div>
                <div className="col-lg-3 p-0 justify-content-center align-items-center d-flex">
                  <Link className="edu-btn datatalent-cta" to="/contact-us">Contact Sales</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default MEAIndustryApplications;